export {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogPrimitiveAction,
	AlertDialogPrimitiveCancel,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "ics-ui-kit/components/alert-dialog";
export { AlertDialogContent } from "./AlertDialogContent";
export { AlertDialogIcon } from "./AlertDialogIcon";
export { AlertConfirm } from "./templates/AlertConfirm";
